import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const ConfigJournal = () => {
  return <ErpTablePage moduleKey="config_journal" />;
};

export default ConfigJournal;